<div class="mb-4">
  <h5 class="cp-green">{{ articleTitle }}</h5>
</div>
<div [innerHtml]="articleHtml" class="mb-4"></div>
<button
  cpGTagEvent
  [params]="{ event_label: 'article_view_more' }"
  class="btn btn-primary"
  (click)="goToFullArticle()">
  Click to View More
</button>
<hr class="my-5" />
